function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8 9c-2.676 0-8 1.571-8 4.667V16h16v-2.333C16 10.57 10.676 9 8 9zM9.936 7.488C11.152 6.8 12 5.504 12 4c0-2.208-1.792-4-4-4S4 1.792 4 4c0 1.504.848 2.8 2.064 3.488A3.97 3.97 0 008 8a3.97 3.97 0 001.936-.512z",
  fill: "#fff"
});

function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _ref);
}

export default SvgUser;